import { nn } from 'date-fns/locale/nn';

const dayValues = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sø', 'må', 'ty', 'on', 'to', 'fr', 'la'],
  abbreviated: ['søn', 'mån', 'tys', 'ons', 'tor', 'fre', 'lau'],
  wide: [
    'søndag',
    'måndag',
    'tysdag',
    'onsdag',
    'torsdag',
    'fredag',
    'laurdag',
  ],
};

// Same behavior as date-fns' buildLocalizeFn for a plain list of values;
// that helper is not part of date-fns 4's public exports.
function day(index, options) {
  const width = options && options.width ? String(options.width) : 'wide';
  return (dayValues[width] || dayValues.wide)[index];
}

export default {
  ...nn.localize,
  day,
};
